import { getErrorMsgAndCode } from "./FrontendHelpers";
import api from "./axios";

export async function GetInventoryReport() {
  try {
    const response = await api.get("/getInventoryReport");
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetActivity(LastID, itemsToFetch) {
  try {
    const response = await api.post("/getActivity", {
      itemsToFetch: itemsToFetch,
      startID: LastID,
    });
    const data = response.data;
    return [data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
